import styled from "styled-components";

// interface myProps {
//   white: boolean;
// }

export const flexRow = () => `
display: flex;
justify-content: center;
align-items: center;

`;
export const flexColumn = () => `
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
`;
export const TopNav = styled.div`
  ${flexRow()};
  position: fixed;
  z-index: 999;
  top: 0;
  gap: 456px;
  width: 100%;
  height: 160px;
  padding-top: 55px;
  padding-bottom: 33px;
  @media (max-width: 768px) {
    gap: 0px;
    height: 92px;
    justify-content: flex-start;
    padding: 0px 36px;
    align-items: flex-end;
  }
  a {
    color: #fefefe;
    font-weight: 700;
    font-size: 14px;
    text-decoration: none;
    transition: all 0.1s ease-in-out;
    .curler {
      position: relative;
      .curl-holder {
        position: absolute;
        overflow: hidden;
        transform: translateY(40%);
        display: flex;
        width: 40px;
        right: 0;
      }
      img {
        width: 205px;
        height: 6px;
        animation: rotate 6s linear infinite;
      }
      .rev-img {
        -webkit-transform: scaleY(-1);
        transform: scaleY(-1);
        transform: rotate(360deg);
      }
      @keyframes rotate {
        0% {
          transform: translateX(-100%);
        }
        50% {
          transform: translateX(-10%);
        }
        100% {
          transform: translateX(0%);
        }
      }
    }
  }
  img {
    width: 84.21px;
    height: 72px;
  }
  .hamburger {
    position: absolute;
    z-index: 99;
    right: 10%;
    top: 60%;
    display: none;
    flex-direction: column;
    gap: 0.2rem;
    transition: all 0.5s ease;
    span {
      background-color: #fefefe;
      width: 12px;
      height: 3px;
    }
    span.active {
      background-color: #0c0c0c;
    }
    .line1 {
      transition: transform 0.5s ease;
    }
    .line2 {
      width: 22px;
      transition: transform 0.5s ease;
    }
    .line3 {
      align-self: flex-end;
      transition: transform 0.5s ease;
    }
  }
  .hamburger.active {
    gap: 0;
    span {
      width: 14px;
    }
    .line1 {
      transform: rotate(45deg);
    }
    .line2 {
      transform: rotate(-45deg);
      width: 22px;
    }
    .line3 {
      transform: rotate(45deg);
    }
  }
  .nav {
    ${flexRow()};
    gap: 48px;
    .active {
      color: #a0a09f;
    }
  }
  @media (max-width: 768px) {
    img {
      width: 44.45px;
      height: 38px;
      margin-bottom: 7px;
    }
    .hamburger {
      display: flex;
    }
    .nav {
      display: none;
    }
  }
`;

export const Button = styled.div`
  width: fit-content;
  padding: 11px 24px;
  border: 1.6px solid #fefefe;
  border-radius: 32px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.6s;
  ${flexRow()};
  gap: 9px;
  img {
    width: 6px;
    height: 10px;
  }
  .p {
    letter-spacing: 1px;
    font-weight: 600 !important;
    font-size: 13px !important;
  }
`;

export const SideBar = styled.div`
  position: fixed;
  top: 11%;
  width: 100%;
  z-index: 900;

  transition: transform 0.6s ease;

  .box {
    ${flexColumn};
    justify-content: flex-end;
    height: 200px;
    padding: 13px 0;
    background: #000;
    gap: 26px;
    a {
      font-size: 13px;
      letter-spacing: 1.2px;
      font-weight: 600;
    }
    a {
      text-decoration: none;
      color: #fefefe;
    }
    .active {
      color: #c0c0c0;
    }
    .icon {
      color: #f9f8f8;
      opacity: 0.5;
    }
  }
  .box.signin {
    border-bottom: none;
  }
`;

export const Blur = styled.div`
  display: block;
  position: fixed;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(6px);
  height: 100vh;
  width: 100%;
  z-index: 499;
`;

export const FooterStyle = styled.footer`
  background: black;
  color: white;
  padding-top: 42px;
  padding-bottom: 70px;
  position: relative;
  z-index: 700;
  h3,
  h5 {
    font-weight: 400;
  }

  h5,
  a {
    font-size: 15px;
    color: #575757;
  }

  h3 {
    font-size: 11px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin-bottom: 16px;
    font-weight: 400;
  }
  .add {
    display: none;
  }
  @include flex-row;
  @media (max-width: 768px) {
    @include flex-column;
  }
  .footer-con {
    width: 874px;
    height: 330.3px;
    @include flex-row;
    gap: 250px;

    .touch-con {
      @include flex-column;
      align-items: flex-start;
      justify-content: space-between;
      height: 100%;
      .touch-box {
        p {
          color: #575757;
          font-size: 28px;
        }
      }
      .social-links {
        width: 100%;
        display: grid;
        grid-template-columns: auto auto;
        justify-content: space-between;
        row-gap: 20px;
        margin-top: -190px;
      }
    }
    .touch-con.second {
      width: 223.44px;
      @media (max-width: 768px) {
        width: 100%;
        .add {
          display: block;
          margin-bottom: 20px;
        }
      }
    }
    @media (max-width: 768px) {
      @include flex-column;
      gap: 28px;
      width: 286px;
      .touch-con {
        width: 286px;
        .bullet {
          display: none;
        }
        .touch-box {
          p {
            font-size: 20px;
            line-height: 42px;
          }
        }
        .social-links {
          grid-template-columns: auto;
          margin-top: 0;
          margin-bottom: 20px;
        }
      }
    }
  }
`;
